import { render, staticRenderFns } from "./TemplateDefault.vue?vue&type=template&id=85c47358&scoped=true&"
import script from "./TemplateDefault.vue?vue&type=script&lang=js&"
export * from "./TemplateDefault.vue?vue&type=script&lang=js&"
import style0 from "./TemplateDefault.vue?vue&type=style&index=0&id=85c47358&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85c47358",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
installComponents(component, {VApp})
